/**
 * Chat-related constants
 * Centralized location for magic numbers and configuration values
 */

/**
 * Minimum age in milliseconds for message recovery attempts.
 * Messages younger than this threshold are considered potentially still processing
 * and will not trigger auto-recovery logic.
 */
export const MESSAGE_RECOVERY_MIN_AGE_MS = 5000;

/**
 * Pending task ID placeholder used before a real task ID is received from the stream
 */
export const PENDING_TASK_ID = "pending";
